// extracted by mini-css-extract-plugin
export var addButton = "_4j-d";
export var bullets = "_4j-e";
export var compact = "_4j-2";
export var container = "_4j-j";
export var extendedWarrantyModal = "_4j-f";
export var learn = "_4j-l";
export var learnMore = "_4j-g";
export var offeringOption = "_4j-3";
export var offeringPrice = "_4j-8";
export var offeringSubtitle = "_4j-7";
export var offeringTitle = "_4j-6";
export var offeringsContainer = "_4j-0";
export var pdpTilesBackground = "_4j-n";
export var plan = "_4j-m";
export var regular = "_4j-1";
export var remove = "_4j-k";
export var seeDetailsIcon = "_4j-i";
export var seeDetailsLink = "_4j-h";
export var selectedOption = "_4j-4";
export var shieldIcon = "_4j-b";
export var shieldIconCompact = "_4j-c";
export var subtitle = "_4j-a";
export var title = "_4j-9";
export var unselectedOption = "_4j-5";